import i18n from '@/i18n'

export default {
  incompleteTickets: (state) => state.incompleteTickets,
  interactiveChartTooltipFooter: (state) => state.hasTouchScreen ? i18n.t('doubleTapToViewTickets') : i18n.t('clickToViewTickets'),
  inventorySummarySelectedLocationId: (state) => state.inventorySummarySelectedLocationId,
  ticketSummarySelectedDestinationId: (state) => state.ticketSummarySelectedDestinationId
}
